// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1kyUi","productName":"Table_productName__17S3P"};